import { decode } from "he";
import { OverlayPanel } from "primereact/overlaypanel";
import { SideBarLinkButton } from "./SideBarLinkButton";
import type { NavigationItem } from "./types";
import { useOverlayMenuKeyboard } from "../../../utils/useOverlayMenuKeyboard";

import styles from "../Menu.module.css";

export const SideBarContextLink = ({
  isMinimized,
  navigationItem,
  renderMenu,
}: {
  isMinimized: boolean;
  navigationItem: NavigationItem;
  renderMenu: (
    items: Array<NavigationItem>,
    insideMenu?: boolean,
  ) => JSX.Element[];
}) => {
  const {
    overlayRef,
    triggerRef,
    menuRef,
    isOpen,
    onShow,
    onHide,
    onTriggerKeyDown,
    onMenuKeyDown,
  } = useOverlayMenuKeyboard();

  return (
    <>
      <SideBarLinkButton
        ref={triggerRef}
        dataCy={navigationItem.dataCy}
        key={`nav_link_${navigationItem.id}`}
        text={decode(navigationItem.text ?? "")}
        hideText={isMinimized}
        icon={navigationItem.icon ?? ""}
        fillColor={navigationItem.fillColor}
        showTooltip={navigationItem.showTooltip && isMinimized}
        truncateText={navigationItem.truncateText}
        onClick={(e) => overlayRef.current?.toggle(e)}
        onKeyDown={onTriggerKeyDown}
        ariaHasPopup={true}
        ariaExpanded={isOpen}
      />
      <OverlayPanel
        ref={overlayRef}
        className={styles.popupMenuOverlay}
        pt={{ content: { className: styles.contentPopupMenuOverlay } }}
        data-cy={`overlay-${navigationItem.dataCy}`}
        onShow={onShow}
        onHide={onHide}
      >
        <nav aria-label={decode(navigationItem.text ?? "")}>
          <div ref={menuRef} role="menu" onKeyDown={onMenuKeyDown}>
            {renderMenu(navigationItem.submenuItems ?? [], true)}
          </div>
        </nav>
      </OverlayPanel>
    </>
  );
};
